import { render } from "./NotificationModal.vue?vue&type=template&id=a948ecfa&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=js"
export * from "./NotificationModal.vue?vue&type=script&lang=js"

import "./NotificationModal.vue?vue&type=style&index=0&id=a948ecfa&lang=css"
import "./NotificationModal.vue?vue&type=style&index=1&id=a948ecfa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a948ecfa"

export default script